import { Inject, Injectable, PLATFORM_ID } from '@angular/core'
import { isPlatformBrowser } from '@angular/common'

@Injectable()
export class RuntimeService {
  protected readonly onClient: boolean

  constructor (
    @Inject(PLATFORM_ID) private readonly platformId: Object,
  ) {
    this.onClient = isPlatformBrowser(this.platformId)
  }

  isClient () {
    return this.onClient
  }

  isServer () {
    return !this.onClient
  }
}
